import { render, staticRenderFns } from "./courseType.vue?vue&type=template&id=55323d36&scoped=true&"
import script from "./courseType.vue?vue&type=script&lang=js&"
export * from "./courseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55323d36",
  null
  
)

export default component.exports